<div class="representante-list">
    <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
        <thead>
            <tr>
                <th class="col-options row-span-2" rowspan="2"></th>
                <th class="col-codigo-integracao-erp row-span-2" rowspan="2">Código ERP</th>
                <th class="col-nome row-span-2" rowspan="2">Nome</th>
                <th class="col-nome-fantasia row-span-2" rowspan="2">Fantasia</th>
                <th class="col-cnpj-cpf row-span-2" rowspan="2">CNPJ / CPF</th>
                <th class="col-situacao text-center row-span-2" rowspan="2">Situação</th>
                <th class="col-modalidade-comercial text-center row-span-2" rowspan="2">Modalidade Comercial</th>
                <th class="col-quantidade-prospects text-center row-span-2" rowspan="2">Prospects</th>
                <th class="col-clientes text-center" colspan="7">Clientes</th>
            </tr>
            <tr>
                <!-- Clientes -->
                <th class="col-quantidade-clientes text-center">Total</th>
                <th class="col-quantidade-clientes-novos text-center">Novos</th>
                <th class="col-quantidade-clientes-positivos text-center">Positivos</th>
                <th class="col-quantidade-clientes-ativos text-center">Ativos</th>
                <th class="col-quantidade-clientes-preinativos text-center">Pré-Inativos</th>
                <th class="col-quantidade-clientes-inativos text-center">Inativos</th>
                <th class="col-quantidade-clientes-congelados text-center">Congelados</th>
                <th class="col-quantidade-clientes-bloqueados text-center">Bloqueados</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="7" class="text-center">
                    {{total?.quantidadeRepresentantes| decimalFormat: 1:0:0}} representante(s)
                </td>
                <td class="col-quantidade-prospects text-center">
                    {{total?.quantidadeProspects | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes text-center">
                    {{total?.quantidadeClientes | decimalFormat: 1:0:0}}
                </td>                 
                <td class="col-quantidade-clientes-novos text-center">
                    {{total?.quantidadeClientesNovos | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes-positivos text-center">
                    {{total?.quantidadeClientesPositivos | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes-ativos text-center">
                    {{total?.quantidadeClientesAtivos | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes-preinativos text-center">
                    {{total?.quantidadeClientesPreInativos | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes-inativos text-center">
                    {{total?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-clientes-congelados text-center">
                    {{total?.quantidadeClientesCongelados | decimalFormat: 1:0:0}}
                </td>                                                    
                <td class="col-quantidade-clientes-bloqueados text-center">
                    {{total?.quantidadeClientesBloqueados | decimalFormat: 1:0:0}}
                </td>                                                                                                               
            </tr>        
    </table>
</div>

<!-- Container para criar dinamicamente os badges das modalidades comerciais -->
<ng-template #badgeModalidadeComercialContainer></ng-template>